// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {Project, InvoiceModel} from '@supermove/models';
import {Currency, Datetime} from '@supermove/utils';

// App
import Table from '@shared/design/components/TableV2Deprecated';
import PaymentActions from 'modules/Project/Billing/components/PaymentActions';
import RefundPayments from 'modules/Refund/components/RefundPayments';

const getColumnDefinitions = ({project, refetch}: any) => [
  {
    flex: 1,
    headerContent: () => {
      return <Table.HeaderText>Timestamp</Table.HeaderText>;
    },
    // @ts-expect-error TS(7031): Binding element 'payment' implicitly has an 'any' ... Remove this comment to see the full error message
    cellContent: ({item: payment}) => {
      return (
        <Table.CellText>
          {Datetime.convertToDisplayDatetime(payment.displayTimestamp, Datetime.DISPLAY_DATETIME)}
        </Table.CellText>
      );
    },
  },
  {
    flex: 2,
    headerContent: () => {
      return <Table.HeaderText>Payment Name</Table.HeaderText>;
    },
    // @ts-expect-error TS(7031): Binding element 'payment' implicitly has an 'any' ... Remove this comment to see the full error message
    cellContent: ({item: payment}) => {
      return <Table.CellText>{payment.name}</Table.CellText>;
    },
  },
  {
    flex: 1,
    headerContent: () => {
      return <Table.HeaderText>Method</Table.HeaderText>;
    },
    // @ts-expect-error TS(7031): Binding element 'payment' implicitly has an 'any' ... Remove this comment to see the full error message
    cellContent: ({item: payment}) => {
      return <Table.CellText>{payment.displayMethod}</Table.CellText>;
    },
  },
  {
    flex: 2,
    headerContent: () => {
      return <Table.HeaderText>Description</Table.HeaderText>;
    },
    // @ts-expect-error TS(7031): Binding element 'payment' implicitly has an 'any' ... Remove this comment to see the full error message
    cellContent: ({item: payment}) => {
      return <Table.CellText>{payment.description}</Table.CellText>;
    },
  },
  {
    flex: 1,
    minWidth: 80,
    headerContent: () => {
      return <Table.HeaderText>Amount</Table.HeaderText>;
    },
    // @ts-expect-error TS(7031): Binding element 'payment' implicitly has an 'any' ... Remove this comment to see the full error message
    cellContent: ({item: payment}) => {
      return <Table.CellText>{Currency.display(payment.totalAmount)}</Table.CellText>;
    },
  },
  {
    width: 80,
    headerContent: () => {
      return <Table.HeaderText>Actions</Table.HeaderText>;
    },
    // @ts-expect-error TS(7031): Binding element 'payment' implicitly has an 'any' ... Remove this comment to see the full error message
    cellContent: ({item: payment}) => {
      return (
        <PaymentActions
          payment={payment}
          refetch={refetch}
          isEnabledRefundPayment={project.organization.features.isEnabledRefundPayment}
        />
      );
    },
  },
];

const InvoicePaymentsTable = ({invoice, refetch}: {invoice: InvoiceModel; refetch: () => void}) => {
  const {payments} = invoice;

  return (
    <Table
      itemKey={'id'}
      items={payments}
      emptyStateText='No Payments'
      columnDefinitions={getColumnDefinitions({project: invoice.project, refetch})}
      rowHook={{
        // The component doesn't need to use the hook or the argument, but we need to pass them in
        hook: () => {},
        hookArgument: {},
        Component: RefundPayments,
        componentProps: {
          refetch,
        },
      }}
      isDense
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
InvoicePaymentsTable.fragment = gql`
  ${PaymentActions.fragment}
  ${RefundPayments.fragment}
  ${Project.getActiveJobsBalanceColor.fragment}

  fragment InvoicePaymentsTable on Invoice {
    id
    project {
      id
      organization {
        id
        features {
          isEnabledRefundPayment: isEnabled(feature: "REFUND_PAYMENT")
        }
      }
    }
    payments {
      id
      name
      method
      displayMethod
      displayTimestamp
      totalAmount
      ...RefundPayments
      ...PaymentActions
    }
  }
`;

export default InvoicePaymentsTable;
